import * as swcHelpers from '@swc/helpers';
import { useLink } from '@grandvisionhq/frk-routing';
import { appendQueryParamToUrl } from '@grandvisionhq/utils';

const useGoToCheckoutLink = (cartId, cartHash, useExpressRoute)=>{
    const { onClick: navigateLogin , href: hrefLogin  } = useLink({
        route: 'checkout.login'
    }) || {};
    const { onClick: navigateShipping , href: hrefShipping  } = useLink({
        route: 'checkout.shipping'
    }) || {};
    const { href: expressCheckoutHref  } = useLink({
        route: 'express.checkout.login',
        params: {
            cartHash: null,
            cartId: null
        }
    }) || {};
    const hrefWithCartId = appendQueryParamToUrl(useExpressRoute && expressCheckoutHref ? expressCheckoutHref : hrefLogin || hrefShipping || '/checkout/shipping', swcHelpers.objectSpread({}, cartId ? {
        cartId
    } : null, cartHash ? {
        cartHash
    } : null));
    if (!hrefLogin && !hrefShipping && !expressCheckoutHref) {
        console.error('This opco is not setup properly. You need to have at least the shipping page configured.');
    }
    return {
        onClick: navigateLogin || navigateShipping,
        href: hrefWithCartId
    };
};

export { useGoToCheckoutLink };
//# sourceMappingURL=use-go-to-checkout-link.js.map
